import { FormattedJob } from 'types';

import { Logo, formatDate, formatLogo, formatName } from './Header-functions';

export interface ContainerComponentChildrenArgs {
  logo: Logo;
  title?: string;
  items: string[];
  reference?: string;
}

interface ContainerProps {
  children: (args: ContainerComponentChildrenArgs) => JSX.Element;
  job?: FormattedJob;
  isLoading?: boolean;
}

const ContainerComponent = ({ children, job, isLoading }: ContainerProps) => {
  const logo = formatLogo(job?.company?.company_logo);
  const title = job?.introduced_to ? job?.description : job?.title;
  const name = formatName(job?.customer);
  const date = formatDate(job?.metadata?.created_at);
  const ref = job?.introduced_to ? job?.title : job?.id;
  const reference = ref ? `Ref: ${ref}` : undefined;

  const items = isLoading
    ? ['0', '1']
    : ([name, date].filter(Boolean) as string[]);

  return children({
    logo,
    title,
    items,
    reference,
  });
};

ContainerComponent.displayName = 'JobSidebar-Header-container';

export default ContainerComponent;
